import { render, staticRenderFns } from "./group-element.vue?vue&type=template&id=416ff4d0&scoped=true"
import script from "./group-element.vue?vue&type=script&lang=js"
export * from "./group-element.vue?vue&type=script&lang=js"
import style0 from "./group-element.vue?vue&type=style&index=0&id=416ff4d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "416ff4d0",
  null
  
)

export default component.exports